module.exports = __webpack_public_path__ + "img/email.2088451f.svg";